/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_ADDRESS } from "../graphql/updateAddress.query";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { filter } from "lodash";
import toast from "react-hot-toast";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUpdateBoxMethods extends IPluginMethodMap {
  updateBox(args: any): Promise<any>;
}

export class UpdateBoxService implements IAgentPlugin {
  readonly methods: IUpdateBoxMethods;

  constructor() {
    this.methods = {
      updateBox: this.updateBox.bind(this),
    };
  }

  async updateBox(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      console.log("args12345", args);
      if (client) {
        const res = await client.mutate({
          mutation: GET_ADDRESS,
          variables: {
            input: {
              mailAddress: {
                addressLine1: args?.address,
                city: args?.cityName,
              },
              availableTime: args?.availableTime,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          toast.success("Mail Address Added!");
          return {
            userData: res?.data?.updateMyProfile,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
